import { ROUTES } from "./path"
import { createElement, lazy } from "react"
import type { AppRouteConfig } from "@/types/navigation"

const Studio = lazy(() => import("@/pages/dashboard/chat/studio"))
const ChatList = lazy(() => import("@/pages/dashboard/chat/list"))

export const chatRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.DASHBOARD.STUDIO.INDEX,
    element: createElement(Studio),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.STUDIO.LIST,
    element: createElement(ChatList),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.STUDIO.THREAD(":threadId"),
    element: createElement(Studio),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
]
